import React, { useEffect, useState } from "react";
import { portalLayouts } from "../generated/portal-layouts.js";
import { loadPortalRuntime } from "../lib/loadScript.js";
import { useStylesheet } from "../lib/useStylesheet.js";

const titles = {
  admin: "STEMEIT Admin",
  client: "STEMEIT Client Portal",
  supplier: "STEMEIT Supplier Portal"
};

export function LegacyPortal({ role }) {
  const [fatalError, setFatalError] = useState("");
  const stylesheet = role === "admin" ? "/styles/admin_site.css" : "/styles/client_site.css";
  useStylesheet(stylesheet);

  useEffect(() => {
    let active = true;
    document.title = titles[role];
    document.body.dataset.portalRole = role;

    loadPortalRuntime(role).catch((error) => {
      console.error(error);
      if (active) setFatalError(error.message || "The portal runtime could not be loaded.");
    });

    return () => {
      active = false;
      delete document.body.dataset.portalRole;
    };
  }, [role]);

  return (
    <>
      <div
        data-legacy-portal-root={role}
        dangerouslySetInnerHTML={{ __html: portalLayouts[role] }}
      />
      {fatalError && (
        <div className="react-runtime-error" role="alert">
          <div>
            <h1>Unable to start the portal</h1>
            <p>{fatalError}</p>
          </div>
        </div>
      )}
    </>
  );
}
